export default __webpack_public_path__ + "static/media/cursor-ic.24c9e339.svg";